/*
 * @Author: WGL
 * @Date: 2023-05-12 14:51:02
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-01 13:35:51
 * @Description:
 */
import { nextTick, toRaw } from 'vue'
import {
  ROLE_VISIBLE_RANGE,
  invoiceInfoConfig,
  CURRENCY,
  CURRENCY_UNIT
} from '@/config/variable.config'
import { version } from '@/config/net.config'
import { handleClipboard } from '@/utils/clipboard'
import { ElLoading, ElNotification } from 'element-plus'
import store from '@/store'
import { t } from '@/utils/i18n'
import request from '@/utils/request'
import { download } from '@/common/js/utils'
import { isFunction } from 'lodash-es'
import VabPrint from '@/extra/VabPrint'
import dayjs from 'dayjs'
import { getUrlParam, numberToFixed, uuid } from '@/utils/index'
import { hideSaveAndAddBtn } from '@/utils/specialCompany'
/**
 * 获取库存文字颜色
 * @param {*} num 数量
 * @param {*} stock 库存
 * @param {*} limit 预警值
 * @returns
 */
export function getStockTextType(num, stock, limit = 0) {
  if (num) {
    const remain = stock - num
    if (remain <= 0) {
      return 'danger'
    } else if (remain <= limit) {
      return 'warning'
    } else {
      return 'primary'
    }
  } else {
    if (stock <= limit) {
      return 'warning'
    } else {
      return 'primary'
    }
  }
}

/**
 * 获取完整标题
 * @param {*} data
 * @param {*} key
 * @param {*} result
 * @returns
 */
export function getFullTitle(data, key = 'title', result = []) {
  if (data?.start_year || data?.end_year) {
    result.unshift(`${data?.start_year || ''}-${data?.end_year || ''}`)
  }
  if (data[key]) {
    result.unshift(data[key])
  }
  if (data?.parent_info) {
    getFullTitle(data.parent_info, key, result)
  }
  return result.join('/')
}
/**
 * 获取用户的数据权限
 */
export function getRoleDataAuthority(labelKey = 'label', valueKey = 'value') {
  const userInfo = store.getters['user/userInfo']
  let result = []
  for (const [key, val] of Object.entries(ROLE_VISIBLE_RANGE)) {
    if (+key <= userInfo.visible_range) {
      result.push({
        [labelKey]: val,
        [valueKey]: +key,
      })
    }
  }
  return result
}

/**
 * 复制发票信息
 * @param {*} item
 * @param {*} event
 */
export function handleCopyInvoice(item, event) {
  console.log('event :>> ', event)
  const text = invoiceInfoConfig
    .map((text) => {
      if (text.key === 'currency') {
        return `${text.title}：${CURRENCY[item[text.key]] || '-'}`
      }
      return `${text.title}：${item[text.key] || '-'}`
    })
    .join('\n')
  handleClipboard(text, event, false)
}

/**
 * 处理多语言布局
 */
export function handleLanguageLayout() {
  let result = {}
  let labelPosition = 'left'
  const leftArr = ['zh_CN', 'zh_TW']
  const language = LS.get('language') || 'zh_CN'
  if (!leftArr.includes(language)) {
    labelPosition = 'top'
    result.labelPosition = labelPosition
  }
  return result
}

/**
 * 处理支持的币种
 * @returns
 */
export function handleSupportCurrency() {
  const supportCurrency =
    store?.getters['sys/sysConfigSetting']?.support_currency || []
  const defaultCurrency =
    store?.getters['sys/sysConfigSetting']?.default_currency || 'CNY'
  const result = {}
  supportCurrency.forEach((item) => {
    result[item] = CURRENCY[item]
  })
  return { supportCurrency: result, defaultCurrency }
}

/**
 * 处理支持的币种
 * @returns
 */
export function handleDefaultUnit() {
  const defaultWeightUnit =
    store?.getters['sys/sysConfigSetting']?.default_weight_unit || 'kg'
  const defaultLengthUnit =
    store?.getters['sys/sysConfigSetting']?.default_length_unit || 'cm'
  return { defaultWeightUnit, defaultLengthUnit }
}
/**
 * 转换货币
 * @param {*} currency 币种
 * @param {*} amount 金额
 * @param {*} targetCurrency 目标币种
 */
export function exchangeCurrency(currency, amount, targetCurrency) {
  if (currency === targetCurrency || !amount) {
    return amount
  } else {
    const currencyToCurrency = `${currency}-${targetCurrency}`
    const rate =
      store?.getters['sys/sysConfigSetting'].exchange_rate[currencyToCurrency]
    return amount * rate
  }
}

/**
 * 异步文件导入
 * @param {*} url
 * @param {*} data
 */
export function handleAsynImportFiles(url, data) {
  const asynImportFileList = store.getters['sys/asynImportFileList']
  store.commit('sys/setAsynImportFileList', [
    {
      url,
      ...data.data,
    },
    ...asynImportFileList,
  ])
}

/**
 * 异步文件导出
 * @param {*} url
 * @param {*} data
 */
export function handleAsynExportFiles(url, data) {
  const asynExportFileList = store.getters['sys/asynExportFileList']
  store.commit('sys/setAsynExportFileList', [
    {
      url,
      ...data,
    },
    ...asynExportFileList,
  ])
}

/**
 * 异步文件导出请求
 * @param {*} url
 * @param {*} params
 * @param {*} filename
 */
export function handleAsynExportFileReq(
  url,
  params,
  filename = '文件',
  callback
) {
  const loadingExport = ElLoading.service({
    lock: true,
    fullscreen: true,
    text: t('正在下载中') || '正在下载中',
    background: 'rgba(255, 255, 255, 0.7)',
  })

  request({
    url: url,
    method: 'get',
    params: params,
  }).then((data) => {
    loadingExport.close()
    callback?.(data)
    if (data && data?.code === 10020) {
      const tips = t('导出数据过多，已添加至异步导出队列生成')
      ElNotification({
        title: 'Success',
        message: tips,
        type: 'success',
      })
      // ElMessage.warning(t('导出数据过多，已添加至异步导出队列生成'))
      handleAsynExportFiles(url, data)
      return
    }
    download(data.http_path, filename, '')
  })
}

/**
 * 获取table的行合并
 * @param {*} key
 * @param {*} list
 */
export function handleGetRowSpan(key = 'id', list = []) {
  const spanArr = []
  let position = 0
  list.forEach((item, index) => {
    if (index === 0) {
      spanArr.push(1)
      position = 0
    } else {
      if (list[index][key] === list[index - 1][key]) {
        spanArr[position] += 1
        spanArr.push(0)
      } else {
        spanArr.push(1)
        position = index
      }
    }
  })
  return spanArr
}

/**
 * 合并的行
 * @param {*} columnIndex
 * @param {*} rowIndex
 * @param {*} spanArr
 * @param {*} mergeIndex 合并的行索引
 * @returns
 */

export function getArraySpanMethod(
  columnIndex,
  rowIndex,
  spanArr = [],
  mergeIndex = []
) {
  if (mergeIndex.includes(columnIndex)) {
    const _row = spanArr[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col,
    }
  }
}

export function pureFunction(asyncFn) {
  // 返回一个新的函数，接受纯函数的参数
  return async function (...args) {
    // 等待异步操作完成
    const data = await asyncFn(...args)
    // 对异步操作的结果进行处理
    console.log('Data:', data)
    // 返回处理后的结果
    return data
  }
}

// 比较版本号
export function compareVersion(v) {
  if (v) {
    if (version != v) {
      setTimeout(() => {
        SS.set('localDict', {})
        windowReload()
      }, 1000)
    }
  }
}
/**
 * 处理请求选项的函数。
 * @param apiConfig - API配置对象，默认为空对象。用于配置请求的各类参数。
 * @param data - 请求数据，可以是任意类型。
 * @param model - 与请求相关联的模型或类型，用于指导数据处理。
 */
export function handleRequestOptions(apiConfig = {}, data, model) {
  let requestOptions = {}
  if (apiConfig?.options) {
    if (isFunction(apiConfig.options)) {
      requestOptions = apiConfig.options(data, model)
    } else {
      requestOptions = apiConfig.options
    }
  }
  return requestOptions
}

/**
 * 查找formList中某一个key的index
 * @param {*} key
 * @param {*} list
 * @param {*} searchKey
 */
export function getFormListIndex(key = '', list = [], searchKey = 'key') {
  if (!key) return 0
  return list.findIndex((item) => item[searchKey] === key)
}

export function printImage(imageUrl) {
  if (imageUrl?.includes('.pdf')) {
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.onload = function () {
      // iframe加载完成后尝试打印
      try {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      } catch (e) {
        console.error('打印失败:', e)
        window.open(imageUrl)
      }
      // 打印后可移除iframe
      document.body.removeChild(iframe)
    }
    iframe.src = imageUrl
    document.body.appendChild(iframe)
    return
  }
  const img = new Image()
  img.src = imageUrl
  VabPrint(img)
}

/**
 * 获取路径中的id
 * @param {*} url
 */
export function getPathId(url = '') {
  const menusObj = store.getters['routes/menusObj']
  // console.log('menusObj :>> ', menusObj);
  return menusObj[url]?.id || ''
}
/**
 * 获取页面权限
 * @param {*} url
 * @returns
 */
export function getPathAuth(url = '', code = '') {
  const menusObj = store.getters['routes/menusObj']
  const operations = menusObj[url]?.operations.map((v) => v.code) || []
  if (code) {
    return operations.includes(code)
  }
  return operations
}

const qrCodeType = {
  product: 'p_',
  order: 'so_',
  stock: 'r_',
  outbound: 'rrc_',
  inbound: 'rrr_',
  deliveryPlan: 'dp_',
  receiveDelivery: 'sd_', // 收货单
  equipment: 'eq_', // 模具
}
/**
 * 生成二维码
 * @param {*} type 类型 product, order, stock, outbound, inbound, deliveryPlan
 * @param {*} id ID
 * @returns
 */
export function handlePageDetailQrcode(type = '', id = '') {
  if (!(type || id)) return ''
  const baseUrl = 'https://s.jinweitec.com/e/?code='
  // 产品 https://s.jinweitec.com/e/?code=p_26439
  // 订单 https://s.jinweitec.com/e/?code=so_23304
  // 仓库 https://s.jinweitec.com/e/?code=r_10003
  // 出库 https://s.jinweitec.com/e/?code=rrc_372
  // 如库 https://s.jinweitec.com/e/?code=rrr_372
  // 发货计划 https://s.jinweitec.com/e/?code=dp_291
  return baseUrl + qrCodeType[type] + id
}
// 页面重新加载
export function windowReload(time = 200) {
  let currentUrl = window.location.href
  let randomTime = `?t=${new Date().getTime()}`
  const hasTime = getUrlParam('t')
  if (hasTime) {
    randomTime = `&${uuid(3)}=${new Date().getTime()}`
  }
  window.location.href = currentUrl + randomTime
  // 重新加载页面
  setTimeout(() => {
    SS.set('reloadTime', dayjs().format('YYYY-MM-DD HH:mm:ss'))
    window.location.reload()
  }, time)
}
export function getMemoryUsage(time = 5) {
  console.log('time :>> ', time)
  // setTimeout(() => {
  //   if ('performance' in window && 'memory' in performance) {
  //     const memory = performance.memory;
  //     // console.log(`Total JS heap size: ${handleFileSize(memory.jsHeapSizeLimit)}`);
  //     // console.log(`Used JS heap size: ${handleFileSize(memory.usedJSHeapSize)}`);
  //     // console.log(`Total available JS heap size: ${handleFileSize(memory.totalJSHeapSize)}`);
  //     const reloadTime = SS.get('reloadTime')
  //     if (memory.usedJSHeapSize > memory.jsHeapSizeLimit * 2 / 3) {
  //       // 内存使用率过高，重新加载页面
  //       if (!reloadTime || (reloadTime && dayjs().diff(dayjs(reloadTime), 'minute') > 10)) {
  //         windowReload(0)
  //       }
  //     }
  //   } else {
  //     console.log('Memory API not supported in this browser.');
  //   }
  // }, 1000 * time)
}
/**
 * 获取快捷时间
 * @returns
 */
export function handleGetShortDate() {
  return [
    {
      text: t('今日'),
      value: () => {
        const end = dayjs().format('YYYY-MM-DD')
        const start = dayjs().format('YYYY-MM-DD')
        return [start, end]
      },
    },
    {
      text: t('昨日'),
      value: () => {
        const end = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        const start = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        return [start, end]
      },
    },
    {
      text: t('本周'),
      value: () => {
        const start = dayjs().startOf('w')
        const end = dayjs().endOf('w')
        return [start, end]
      },
    },
    {
      text: t('上周'),
      value: () => {
        const lastWeek = dayjs().subtract(1, 'w').startOf('w')
        const endlastWeek = dayjs().subtract(1, 'w').endOf('w')
        return [lastWeek, endlastWeek]
      },
    },
    {
      text: t('本月'),
      value: () => {
        // 本月
        const month = dayjs().startOf('M')
        const endMonth = dayjs().endOf('M')
        return [month, endMonth]
      },
    },
    {
      text: t('上月'),
      value: () => {
        const lastMonth = dayjs().subtract(1, 'M').startOf('M')
        const endlastMonth = dayjs().subtract(1, 'M').endOf('M')
        return [lastMonth, endlastMonth]
      },
    },
    {
      text: t('最近三个月'),
      value: () => {
        const month = dayjs().format('YYYY-MM-DD')
        const endMonth = dayjs(month).subtract(3, 'M')
        return [endMonth, month]
      },
    },
    {
      text: t('最近半年'),
      value: () => {
        const month = dayjs().format('YYYY-MM-DD')
        const endMonth = dayjs(month).subtract(6, 'M')
        return [endMonth, month]
      },
    },
  ]
}

/**
 * 获取产品库存
 * @param data
 * @returns
 */
export function getProductStock(data, stock = false) {
  const productInfo = data?.product_info || data || {}
  const stockNum = +productInfo?.stock || 0
  const freezeNum = productInfo?.dynamic_info?.freeze_num || 0
  const unitTetx = productInfo?.unit || '-'
  if (stock) {
    return stockNum
  }
  return `${stockNum}-${freezeNum}=${stockNum - freezeNum} (${unitTetx})`
}

/**
 * 获取页面字段权限
 * @param {*} key
 * @param {*} url
 */
export function getPageFieldAuth(key, url) {
  const allUserFieldList = store.getters['sys/userFieldList']
  const urlId = getPathId(url)
  return !!allUserFieldList[urlId]?.[key]
}
/**
 * 处理缓存搜索条件
 * @param {*} path
 * @param {*} save
 * @param {*} data
 * @returns
 */
export function handleCacheSearch(path, save = false, data = {}) {
  console.log('path', path, save, data)
  const openDrawer = store.getters['sys/hasOpenDrawer']
  // 侧边弹窗内的搜索条件不进行缓存
  if (openDrawer) return
  const userInfo = store.getters['user/userInfo']
  const uniqueIndex = `${path}|${userInfo.company_id}|${userInfo.id}`
  const localCacheSearchSetting = LS.get('localCacheSearchSetting') || {}
  if (save) {
    localCacheSearchSetting[uniqueIndex] = data
    LS.set('localCacheSearchSetting', localCacheSearchSetting)
    return null
  } else {
    return localCacheSearchSetting[uniqueIndex]
  }
}
/**
 * 处理缓存排序条件
 * @param {*} path
 * @param {*} save
 * @param {*} data
 * @returns
 */
export function handleCacheSortOrder(path, save = false, data = {}) {
  console.log('path', path, save, data)
  const openDrawer = store.getters['sys/hasOpenDrawer']
  // 侧边弹窗内的搜索条件不进行缓存
  if (openDrawer) return
  const userInfo = store.getters['user/userInfo']
  const uniqueIndex = `${path}|${userInfo.company_id}|${userInfo.id}`
  const localCacheSortOrder = LS.get('localCacheSortOrder') || {}
  if (save) {
    localCacheSortOrder[uniqueIndex] = data
    LS.set('localCacheSortOrder', localCacheSortOrder)
    return null
  } else {
    return localCacheSortOrder[uniqueIndex]
  }
}
/**
 * 打开抽屉
 * @param {*} row
 * @param {*} item
 */
export function handleOpenDraw(row, item) {
  store.commit('sys/setOpenDrawer', true)
  const newItem = {
    ...item,
  }
  if (
    item?.publicDrawerConfig?.openName &&
    isFunction(item?.publicDrawerConfig?.openName)
  ) {
    newItem.publicDrawerConfig.openName =
      item?.publicDrawerConfig?.openName(row)
  }
  // 抽屉属性配置
  nextTick(() => {
    store.commit('sys/setOpenPageDrawerConfig', {
      row: toRaw(row),
      item: toRaw(newItem),
    })
  })
}
/**
 * 自动保存表单
 * @returns
 */
export function handleAutoSaveForm() {
  console.log('handleAutoSaveForm')
  const autoSaveFormMode = store.getters['sys/autoSaveFormMode']
  // // 侧边弹窗内的搜索条件不进行缓存
  // if (openDrawer) return
  // const userInfo = store.getters['user/userInfo']
  // const uniqueIndex = `${path}|${userInfo.company_id}|${userInfo.id}`
  // const localCacheSearchSetting = LS.get('localCacheSearchSetting') || {}
  return autoSaveFormMode
}
/**
 * 根据指定字段值变化对列表进行分组
 * @param {*} list 源数据
 * @param {*} key 分组依据的字段名
 * @param {*} initial 初始化对比值
 */
export function groupWhenKeyChanges(list = [], key = 'id', initial = 0) {
  const result = []
  let currentGroupValue = initial

  for (const item of list) {
    const val = item[key]

    if (val !== currentGroupValue) {
      result.push({ ...item, groupList: [] })
      currentGroupValue = val
    } else {
      const lastIndex = result.length - 1
      result[lastIndex].groupList.push(item)
    }
  }

  return result
}
/**
 * 任务剩余天数
 * @param {*} row
 * @returns
 */
export function handleTaskRemaindDay(row) {
  const start_time = row.start_time || row.date
  if (row.finish_time && start_time) {
    return `${t('用时')}${dayjs(row.finish_time).diff(
      dayjs(start_time),
      'day'
    )}${t('天')}`
  }
  if (row.status < 10 && row.status >= 0) {
    const end_time = row.end_time
    if (dayjs().isBefore(start_time, 'day')) {
      return t(`未开始`)
    }
    if (dayjs().isAfter(end_time, 'day')) {
      return `${t('逾期')}${dayjs().diff(dayjs(end_time), 'day')}${t('天')}`
    } else {
      return `${t('逾期')}${dayjs(end_time).diff(dayjs(), 'day') + 1}${t('天')}`
    }
  }
  if (row.status === 10) {
    return t('已完结')
  }
}
/**
 * 安全的数学公式计算函数
 * @param {string} formula - 数学公式字符串，如 "(cost+200)*1.3/7"
 * @param {object} variables - 变量对象，如 { cost: 100 }
 * @returns {number} 计算结果
 * @throws {Error} 当计算出错时抛出错误
 */
export function calculateFormula(formula, variables = {}) {
  try {
    // 参数验证
    if (typeof formula !== 'string') {
      throw new Error(t('公式必须是字符串类型'))
    }

    if (typeof variables !== 'object' || variables === null) {
      throw new Error(t('变量必须是对象类型'))
    }

    // 替换变量
    let replacedFormula = formula
    for (const [key, value] of Object.entries(variables)) {
      // 确保变量名是有效的标识符
      if (!/^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(key)) {
        throw new Error(`${t('无效的变量名')}: ${key}`)
      }

      // 替换变量，使用正则表达式确保完整匹配
      const regex = new RegExp(`\\b${key}\\b`, 'g')
      replacedFormula = replacedFormula.replace(regex, value)
    }

    // 基本安全检查：只允许数字、运算符、括号和小数点
    const allowedPattern = /^[0-9+\-*/().\s]+$/
    if (!allowedPattern.test(replacedFormula)) {
      throw new Error(t('公式包含不允许的字符'))
    }

    // 使用 Function 构造函数计算
    const calculate = new Function('return ' + replacedFormula)
    const result = calculate()

    // 检查结果是否为有效数字
    if (typeof result !== 'number' || !isFinite(result)) {
      throw new Error(t('计算结果不是有效数字'))
    }

    return numberToFixed(result, 2)
  } catch (error) {
    throw new Error(`${t('计算失败')}: ${error.message}`)
  }
}

export function getTaxAmount(price, taxRate, adjust = true) {
  let realPrice = adjust ? price * (1 + taxRate / 100) : price / (1 + taxRate / 100)
  return {
    price: numberToFixed(realPrice, 2),
    taxPrice: numberToFixed((adjust ? price : realPrice) * (taxRate / 100), 2),
  }
}
/**
 * 保存并新增按钮
 * @returns 保存并新增按钮
 */
export function handleSaveAndAddBtn(defaultConfig = {}) {
  const isHide = hideSaveAndAddBtn()
  if (!isHide) {
    defaultConfig.footer.splice(1, 0, {
      action: 'confirmAdd',
      title: '保存并新增',
      attrs: {
        type: 'primary',
      },
    })
  }
}
export function getPriceInfo(currency, price) {
  const currencyText = CURRENCY_UNIT[currency] || ''
  let priceText = price || '-'
  if (price === 0 || price === '0' || price === '0.00') {
    priceText = 0
  }
  return `${currencyText}${priceText}`
}